export default __webpack_public_path__ + "static/media/logo1.1bf2ee31.webp";